import { render } from "./App.vue?vue&type=template&id=f6bd07b4"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=f6bd07b4&lang=css"

import exportComponent from "/github/workspace/timmies-helper-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__